export const vimeoId = (url) => {
  if (!url) return null;
  const m = String(url).match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (m) return m[1];
  if (/^\d+$/.test(String(url).trim())) return String(url).trim();
  return null;
};

export const youtubeId = (url) => {
  if (!url) return null;
  const m = String(url).match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/))([A-Za-z0-9_-]{6,})/);
  return m ? m[1] : null;
};

// Derives a display thumbnail straight from YouTube/Vimeo when the item has no stored poster.
export const videoThumbUrl = (item) => {
  if (!item?.video) return "";
  const y = youtubeId(item.video);
  if (y) return `https://img.youtube.com/vi/${y}/hqdefault.jpg`;
  const v = vimeoId(item.video);
  if (v) return `https://vumbnail.com/${v}.jpg`;
  return "";
};
